export default "__VITE_ASSET__D5vb7ySd__"